import { Tooltip } from '@byecode/ui'
import { TagIcon, useAtomAction, useAtomData } from '@lighthouse/shared'
import React from 'react'
import styled from 'styled-components'

import { AppSystemPageAtom } from '@/atoms/application/state'
import { rollbackPageStackHistoryAtom } from '@/atoms/page/action'

import { RedoUndo } from './RedoUndo'

interface PageOperationProps {
    style?: React.CSSProperties
    hoverColor?: string
}

const SCxContainer = styled.div`
    position: relative;
    width: 40%;
    display: flex;
    align-items: center;
    gap: 8px;
`

const PageOperation: React.FunctionComponent<PageOperationProps> = ({ style, hoverColor }) => {
    const appSystemPage = useAtomData(AppSystemPageAtom)
    const { run: popStack } = useAtomAction(rollbackPageStackHistoryAtom)
    const { run: setAppSystemPage } = useAtomAction(AppSystemPageAtom)

    return (
        <SCxContainer style={style}>
            <Tooltip title="返回">
                <TagIcon
                    size={32}
                    radius={6}
                    iconColor="var(--color-gray-400)"
                    background="var(--color-gray-100)"
                    icon="ArrowLeftSmall"
                    hoverBackground="var(--color-gray-200)"
                    hoverColor="var(--color-black)"
                    enableHover
                    onClick={() => {
                        appSystemPage ? setAppSystemPage(null) : popStack()
                    }}
                />
            </Tooltip>
            <RedoUndo />
        </SCxContainer>
    )
}

export default PageOperation
